import { cn } from './cn';

/**
 * Placeholder bar; with `label` it is the named status of what is loading, otherwise decorative. It reads on the page
 * and on a chrome card alike (the border colour), and a soft band sweeps across it (`os-shimmer`: translate only; at
 * rest under reduced motion).
 */
export function Skeleton({ className, label }: { className?: string; label?: string }) {
  const base = cn('os-shimmer block rounded-md bg-border', className);
  return label ? <span role="status" aria-label={label} className={base} /> : <span aria-hidden="true" className={base} />;
}
